import { ReactElement } from 'react'
import Backdrop from '@mui/material/Backdrop'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { Status } from 'src/store/store'

interface Props {
  entities: Status[]
  loading?: boolean
}

let Loading = ({ entities, loading }: Props): ReactElement => (
  <Backdrop
    open={
      !!loading ||
      !entities.every(
        (entity) => entity === 'fulfilled' || entity === 'rejected' || !entity,
      )
    }
  >
    <Box sx={{ position: 'relative' }}>
      <img src="/logo.svg" alt="logo" width={120} height={120} />
      <CircularProgress
        size={120}
        thickness={1}
        sx={{ position: 'absolute', top: 0 }}
      />
    </Box>
  </Backdrop>
)

export default Loading
